import { mapGetters } from "vuex";
import { makeGenericContractFromContractFrequency } from "../util/contracts";
import { makeOfferBasketIntoDeliveredIn, createServerSideBasket } from "../api/basket";

export default {
  computed: {
    ...mapGetters("orders", ["marketWindowId"]),
  },
  methods: {
    createLocalBasket({ basketId, expiry, offer: apiOffer, brands }) {
      let offer = apiOffer;
      const basket = {
        offers: [],
        id: basketId,
        basketExpiry: expiry,
        isDeliveredIn: offer.location_id ? true : false,
        isBunkering: offer.networkId ? true : false,
        isContract: offer.isContract ? true : false,
        reference: "",
        deliveredInData: {},
        basketCreated: new Date(new Date().getTime() - 30 * 1000),
        brands,
      };

      if (!basket.isDeliveredIn) {
        if (basket.isContract) offer = makeGenericContractFromContractFrequency(offer);

        offer = Object.assign({}, offer, { quantity: null });
        offer.price = Number(offer.price.toFixed(2));
        basket.offers.push(offer);
        basket.orderNotes = "";
        return basket;
      }
      makeOfferBasketIntoDeliveredIn(basketId, offer);
      basket.deliveredInData = offer;
      const myOffer = Object.assign({}, offer, { quantity: null, price: Number(offer.dayDeliveryPpl.toFixed(2)) });
      basket.offers.push(myOffer);
      basket.deliveryNotes = "";
      basket.keroPotsOptions = [0, 6250, 12500, 18750, 25000, 31250, 37500];
      basket.restPotsOptions = [0, 6000, 12000, 18000, 24000, 30000, 36000];
      return basket;
    },
    openBasket: async function (offer, event) {
      const initialText = event.srcElement.innerHTML;
      event.srcElement.disabled = true;
      event.srcElement.innerHTML = "Processing...";

      const apiBasket = await createServerSideBasket(this.marketWindowId, [offer]);
      apiBasket.offer = offer;

      //Calling component needs a basket object to pass to the basket modal object
      this.basket = this.createLocalBasket(apiBasket);
      //Calling component needs showBasket to show modal. Realistically below should be fed back to calling component, rather than just changing values that exist there
      this.showBasket = true;

      event.srcElement.disabled = false;
      event.srcElement.innerHTML = initialText;
    },
    populateOrderCaptureBasket({
      basketId,
      offers,
      expiry,
      brand,
      deliveredInData,
      customLiftingPeriod,
      orderReference,
    }) {
      const basket = {
        offers: offers.map((offer) => ({ ...offer })),
        id: basketId,
        basketExpiry: expiry,
        deliveredInData,
        brand,
        customLiftingPeriod,
        orderReference,
      };
      if (!deliveredInData || !deliveredInData.location) {
        return basket;
      }
      basket.deliveryNotes = "";
      basket.keroPotsOptions = [0, 6250, 12500, 18750, 25000, 31250, 37500];
      basket.restPotsOptions = [0, 6000, 12000, 18000, 24000, 30000, 36000];
      return basket;
    },
  },
};
